<!-- TAB A - SERVICES -->
<!-- Services Costs Widget-->
<div class="row pt-3 pb-3">
    <div class="col-md-3 col1" align="center">
        <h2>{{serviceYearly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
        <h5>Total year to date</h5>
        <p>___________________</p>
        <font *ngIf="!serviceYearly">NO RECORD FOR YEAR TO DATE</font>
        <font  *ngIf="serviceYearly">TOTAL SERVICE COST FOR YEAR TO DATE<br /></font>
    </div>

    <div class="col-md-3 col2" align="center">
        <h2>{{serviceMonthly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
        <h5>Total this month</h5>
        <p>___________________</p>
        <font *ngIf="serviceMonthly == 0">NO RECORD FOR THE CURRENT MONTH</font>
        <font *ngIf="serviceMonthly > 0">TOTAL SERVICE COST FOR THE CURRENT MONTH</font>
    </div>

    <div class="col-md-3 col3" align="center">
        <h2>{{serviceWeekly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
        <h5>Total this week</h5>
        <p>___________________</p>
        <font *ngIf="serviceWeekly == 0">NO RECORD FOR THE CURRENT WEEK</font>
        <font *ngIf="serviceWeekly > 0">TOTAL SERVICE COST FOR THE CURRENT WEEK</font>
    </div>

    <div class="col-md-3 col4" align="center">
        <h2>{{serviceRecentCost | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
        <h5>Latest SERVICE Cost</h5>
        <p>___________________</p>
        <font *ngIf="serviceRecentCost == 0">NO SERVICE COST ON RECORD</font>
        <font *ngIf="serviceRecentCost > 0"> SERVICE COST FOR {{serviceRecentRego}} ON
            {{ (serviceRecentDate !== null) ? (serviceRecentDate | date: 'dd MMM yyyy') : "UNRECORDED DATE"  }}</font>
    </div>        
</div><!-- End of Services Costs Widget-->

<!-- Featured Buttons -->
<div class="row pt-0 mt-0 pb-0 mb-0">
    <div class="col-md-12">
        <button type="button" class="btn btn-secondary btn-sm mb-1 mr-1" aria-expanded="false" ngbTooltip="Add New Service" (click)="openServiceModal(null)">
            <span class="sr-only">Add</span>
            <i class="fa fa-lg fa-plus"></i>
            <span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Add</span>
        </button>
        
        <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print('service-print-section')" placement="bottom" [disabled]="serviceCount < 1" ngbTooltip="Print List">
            <i class="fa fa-lg fa-print"></i>
            <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
        </button>

        <div class="btn-group mr-1">
            <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="serviceCount < 1"
                placement="bottom" ngbTooltip="Export List">
                <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
            </button>
            <div class="dropdown-menu fs-12">
                <a (click)="services_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                <a (click)="services_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a>
                <a (click)="services_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
            </div>
        </div>

        <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1" (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
            <i class="fa fa-lg fa-filter"></i>
            <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
        </button>

        <button type="button" [ngClass]="(showSidebar)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1" (click)="toggleSideBar()" placement="bottom" ngbTooltip="Toggle Sidebar">
            <i class="fa fa-lg fa-toggle-right"></i>
            <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Sidebar</span>
        </button>
       
        <div class="btn-group mb-1">
            <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                placement="bottom" ngbTooltip="Show/Hide Columns">
                <span class="sr-only">Toggle Dropdown</span>
                <i class="fa fa-lg fa-check-square-o"></i>
                <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
            </button>

            <div class="dropdown-menu fs-12" style="width: 150px;">
                <div class="col-md-12 mb-3 fs-12">
                    <input type="checkbox" [(ngModel)]="showDate"> Date<br />
                    <input type="checkbox" [(ngModel)]="showRego"> REGO<br />
                    <input type="checkbox" [(ngModel)]="showFleetType"> Fleet Type<br />
                    <input type="checkbox" [(ngModel)]="showDescription"> Description<br />
                    <input type="checkbox" [(ngModel)]="showOdometer"> Odometer<br /> 
                    <input type="checkbox" [(ngModel)]="showServiceInterval"> Service Interval<br />
                    <input type="checkbox" [(ngModel)]="showSupplier"> Supplier<br />
                    <input type="checkbox" [(ngModel)]="showCost"> Cost<br />
                    <input type="checkbox" [(ngModel)]="showReceiptNo"> Receipt No<br />
                    <input type="checkbox" [(ngModel)]="showFile"> File<br />
                </div>
            </div>
        </div>
        
        <span *ngIf="myDropDown=='range'" class="pull-right" >&nbsp;
            <input type="text"   width="120" class="mb-1" class="dateRangeInput" matInput
            ngxDaterangepickerMd
            [locale]="locale"
            startKey="start"
            endKey="end"
            [showWeekNumbers]="true"
            [showDropdowns]="true"
            [(ngModel)]="serviceDateRange"
            (ngModelChange)="processServiceDateRange($event)"
            name="daterange"
            [autoApply]="true"
            opens="left"
            drops="down"
            [maxDate]="maxDate"
            />
        </span>

        <select [(ngModel)]="myDropDown" (ngModelChange)="onChangeofOptions($event)" class="dateFilter  btn btn-sm  btn-secondary mb-1 pull-right">
            <option value="today">Today</option>
            <option value="week">This Week</option>
            <option value="month">This Month</option>
            <option value="year">This Year</option>
            <option value="7">Last 7 days</option>
            <option value="14">Last 14 days</option>
            <option value="30">Last 30 days</option>
            <option value="90">Last 90 days</option>
            <option value="all">All Dates</option>
            <option value="range">Custom date range</option>
        </select>
    </div>
</div><br> <!-- Featured Buttons -->

<!-- Search Services List -->
<div class="row pt-0 mb-0">
    <div class="col-md-12">
        <div widget class="card border-0 box-shadow" *ngIf="showFilters">
            <div class="card-header border-0 text-muted">
                <h5 class="mb-0">Search Services:</h5>
                <div class="widget-controls">
                    <a data-widgster="close" class="transition" (click)="toggleFilters()"><i
                        class="fa fa-times"></i></a>
                </div>
            </div>
            <div class="card-body card-header pt-0 widget-body">
                <div class="row">
                    <div class="form-group col">
                        <label>Provider:</label>
                        <select class="form-control form-control-sm" placeholder="Select"
                            [(ngModel)]="filterServiceProvider" (change)="updateFilter(prefixService)">
                            <option selected disabled>Select..</option>
                            <option *ngFor="let p of providers" value="{{p.id}}">{{p.company_name}}</option>
                        </select>
                    </div>
                    <div class="form-group col" *ngIf="parent!=prefix_fleet">
                        <label>REGO:</label>
                        <input class="form-control form-control-sm" type="text" [(ngModel)]="filterServiceRego"
                            (keyup)="updateFilter(prefixService)">
                    </div>
                </div>
                <div class="row" *ngIf="!isFilterEmpty">
                    <div class="col-md-12">
                        <button type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters()">
                            <span class="badge badge-pill badge-white text-primary ml-1"><i
                                class="fa fa-lg fa-filter"></i></span>&nbsp;
                            <span>Reset Filters</span>
                        </button> &nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
</div><!-- Search Services List -->

<br *ngIf="showFilters" />
<!-- SERVICES TABLE -->
<div class="row pt-3">
    <div [ngClass]="(showSidebar) ? 'col-md-8' : 'col-md-12'" align="left">
        <span>
            Items: <span style="color: rgb(23, 98, 141);">{{ (totalService !== null) ?   (totalService) : "0"}}</span>   |  
            Average Amount: <span style="color: rgb(23, 98, 141);">{{ (averageServiceAmount  && averageServiceAmount !== null) ?   '$' + (averageServiceAmount | number:'1.2-2') : "0.00"}}</span> |
            Total Amount: <span style="color: rgb(23, 98, 141);">{{ (totalServiceAmount  && totalServiceAmount !== null) ?   '$' + (totalServiceAmount | number:'1.2-2') : "0.00"}}</span>
        </span>
        <ngx-loading [show]="loading_indicator1"></ngx-loading>
        <div class="">
            <ngx-datatable *ngIf="service_rows"
                [loadingIndicator]="loading_indicator1"
                class="material" 
                [rows]="service_rows" 
                [columnMode]="'force'"
                [footerHeight]="40"
                [rowHeight]="'auto'"
                [limit]="10" 
                [selected]="selected4" 
                [selectionType]="'single'"
                [scrollbarH]="true">

                <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="70">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div align="left" style="padding-right:20px">
                            <a container="body" placement="top" ngbTooltip="Edit" (click)="openServiceModal(row)"><i
                                    class="fa fa-lg fa-pencil"></i></a>&nbsp;
                            <a container="body" placement="top" ngbTooltip="Delete"
                                (click)="openDeleteObjModal(row, prefixService, modalDeleteObj)"><i
                                    class="fa fa-lg fa-trash"></i></a>
                        </div>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Date" prop="date_done" headerClass="header" [width]="100" *ngIf="showDate">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div align="left" placement="top" container="body" [ngbTooltip]="valueToolTip"
                            style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; ">
                            {{ (formatDate(value) !== null) ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column *ngIf="showRego" name="Fleet ID (REGO)" prop="rego" headerClass="header" [width]="120">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div align="left" placement="top" container="body" [ngbTooltip]="valueToolTip"
                            style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; ">
                            {{value}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column *ngIf="showFleetType" headerClass="header">
                    <ng-template let-column="column" ngx-datatable-header-template >
                        Fleet Type
                    </ng-template>
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{row.fleet_type}} <span *ngIf="row.subtype !=='' && row.subtype != null">- {{row.subtype}}</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Description" prop="service_description" headerClass="header" *ngIf="showDescription">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div align="left" placement="top" container="body" [ngbTooltip]="valueToolTip"
                            style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; ">
                            {{value}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [width]="100" name="Odometer" prop="mileage" headerClass="header" *ngIf="showOdometer"></ngx-datatable-column>

                <ngx-datatable-column name="Service Interval" prop="next_klms_service" headerClass="header" *ngIf="showServiceInterval"></ngx-datatable-column>

                <ngx-datatable-column name="Supplier" prop="provider" headerClass="header" *ngIf="showSupplier"></ngx-datatable-column>

                <ngx-datatable-column prop="cost" name="Cost" headerClass="header-currency" [width]="110" *ngIf="showCost">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        <div align="right" style="padding-right:10px"> ${{ value | number:'2.2-5'}}</div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Receipt No" prop="receipt_no" headerClass="header" *ngIf="showReceiptNo"></ngx-datatable-column>

                <ngx-datatable-column name="File" prop="file" headerClass="header" *ngIf="showFile">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        <a href="{{folderPath}}{{value}}" target="_new">{{value}}</a>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>
        </div>
    </div>

    <!-- DETAILS SIDEBAR -->
    <div class="col-md-4" *ngIf="showSidebar">
        <div widget class="card border-0 box-shadow selected-column">
            <div class="card-header transparent border-0 text-muted"></div>
            <div class="card-body pt-0 widget-body">
                <ul>
                    <div *ngIf="selected4">
                        <div *ngFor='let sel4 of selected4'>
                            <div class="col-md-12">
                                <h6 class="titleHeader" style="padding-left: 0px;">{{sel4["rego"]}} Details</h6>
                                <a *ngIf="sel4['file']!==null && sel4['file']!==''" href="{{folderPath}}{{sel4['file']}}" target="_new"
                                    title="View File"><i class="fa fa-file"></i>
                                </a><br/>

                                <tr>
                                    <td><b>Service Date:</b></td>
                                    <td class="col-md-7">{{ (formatDate(sel4["date_done"]) !== null) ? (formatDate(sel4["date_done"]) | date: 'dd MMM yyyy') : "No Date"  }}-{{sel4.time_done}}</td>
                                </tr>

                                <tr>
                                    <td><b>Description:</b></td>
                                    <td class="col-md-7">{{sel4.service_description}}</td>
                                </tr>

                                <tr *ngIf="parent!=prefix_fleet">
                                    <td><b>Fleet Type:</b></td>
                                    <td class="col-md-7">{{sel4.fleet_type}}  
                                        <span *ngIf="sel4.subtype !=='' && sel4.subtype != null">- {{sel4.subtype}}</span> 
                                    </td>
                                </tr>

                                <tr>
                                    <td><b>Supplier:</b></td>
                                    <td class="col-md-7">{{sel4.provider}}</td>
                                </tr>

                                <tr>
                                    <td><b>Service Odometer:</b></td>
                                    <td class="col-md-7">{{sel4.mileage}}</td>
                                </tr>

                                <tr *ngIf="parent!=prefix_fleet">
                                    <td><b>Current Odometer:</b></td>
                                    <td class="col-md-7">{{sel4.current_odometer}}</td>
                                </tr>
                                
                                <tr>
                                    <td><b>KLMS to Next Service:</b></td>
                                    <span class="col-md-7" *ngIf = "(sel4.mileage > 0) &&((sel4.mileage + sel4.service_interval) >= sel4.current_odometer)">
                                        <span class="col-md-5" style="font-weight: bold;">{{(sel4.mileage + sel4.service_interval) - sel4.current_odometer | number:'1.0-0'}}</span>
                                    </span> 
                                    <span class="col-md-7" *ngIf = "(sel4.mileage > 0) && (sel4.current_odometer > (sel4.mileage + sel4.service_interval))">Missed service by 
                                        <span style="font-weight: bold;">{{((sel4.mileage + sel4.service_interval) - sel4.current_odometer) * -1  | number:'1.0-0'}}</span> klms
                                    </span> 
                                    <span class="col-md-7" *ngIf="sel4.mileage == 0 && (sel4.current_odometer > sel4.service_interval)">Missed service by
                                        <span class="col-md-5" style="font-weight: bold;"> {{ (sel4.service_interval - sel4.current_odometer) * -1  | number:'1.0-0'}}</span> klms. No service odometer for this record.
                                    </span> 
                                    <span class="col-md-7" *ngIf="sel4.mileage == 0 && (sel4.service_interval > sel4.current_odometer)">
                                        <span class="col-md-5" style="font-weight: bold;">{{ sel4.service_interval - sel4.current_odometer  | number:'1.0-0'}}</span> klms to next Service. No service odometer for this record.
                                    </span>
                                </tr>
                                
                                <tr>
                                    <td><b>Cost:</b></td>
                                    <td class="col-md-7">${{ sel4.cost | number:'3.2-5'}}</td>
                                </tr>

                                <tr>
                                    <td><b>Receipt No:</b></td>
                                    <td class="col-md-7">{{sel4.receipt_no}}</td>
                                </tr>

                                <tr>
                                    <td><b>Driver:</b></td>
                                    <td class="col-md-7">
                                        <span *ngFor="let d of drivers"> 
                                            <strong *ngIf="sel4['driver_id'] == d.id">{{d.full_name}}</strong>
                                        </span>
                                    </td>
                                </tr>

                                <tr>
                                    <td><b>Fault:</b></td>
                                    <td class="col-md-7">{{sel4.fault}}</td>
                                </tr>

                                <tr>
                                    <td><b>Hours:</b></td>
                                    <td class="col-md-7">{{sel4.hours}}</td>
                                </tr>

                                <tr>
                                    <td><b>Note:</b></td>
                                    <td class="col-md-7">{{sel4.note}}</td>
                                </tr>

                            </div><br />
                            <div class="col-md-12">
                                <button type="button" class="btn btn-secondary mb-1 btn-sm" (click)="openServiceModal(sel4);">
                                    <span class="badge badge-pill badge-white text-primary ml-1"><i
                                            class="fa fa-lg fa-pencil"></i></span>
                                    Edit
                                </button>&nbsp;
                                <button type="button" class="btn btn-danger mb-1 btn-sm"
                                    (click)="openDeleteObjModal(sel4, prefixService, modalDeleteObj)">
                                    <span class="badge badge-pill badge-white text-primary ml-1"><i
                                            class="fa fa-lg fa-trash"></i></span>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!selected4.length" class="text-center"> 
                        <p> Select an item to display details. </p>
                    </div>
                </ul>
            </div>
        </div>
    </div><!--  END DETAILS SIDEBAR  -->
</div> <!-- SERVICES TABLE -->

<div class="row">
    <div class="col-md-12">
        <small><i>Move your cursor on a row to select. Use the Operations buttons for details and
                actions.</i></small>
    </div>
</div>
<!-- END TAB A -->


<!-- START OF SERVICE FORM -->
<ng-template #modalService let-close="close">
<div class="modal-header">
    <h5 class="modal-title" *ngIf="isEditMode==false">Add New Service</h5>
    <h5 class="modal-title" *ngIf="isEditMode==true">Edit Service Data</h5>
    <button type="button" class="close" (click)="modalClose()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<form [formGroup]="serviceForm" novalidate (ngSubmit)="onSubmitService(serviceForm.value)">
    <div class="modal-body">
        <div class="row pt-0">
            <div class="form-group col-md-4" >
                <h6>Date<span class="text-danger">*</span> :</h6>
                <input formControlName="date_done" class="form-control form-control-sm" type="date" required>
                <div *ngIf="serviceForm.controls.date_done.touched">
                    <div *ngIf="serviceForm.controls.date_done.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-4"> 
                <h6>Time:</h6>
                <ngb-timepicker formControlName="time_string" [meridian]="true" class="changeSize"></ngb-timepicker>  
               
            </div>   

            <div class="form-group col-md-4"> 
                <h6>Supplier:<span class="text-danger">*</span></h6>
                <select class="form-control form-control-sm" placeholder="Select" formControlName="provider_id" required> 
                    <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                    <option *ngFor="let p of providers" value="{{p.id}}">{{p.company_name}}</option>
                </select>
                <div *ngIf="serviceForm.controls.provider_id.touched">
                    <div *ngIf="serviceForm.controls.provider_id.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                </div>
            </div>
            <div class=" form-group col-md-4" >
                <h6>Cost<span class="text-danger">*</span> :</h6>
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend"><div class="input-group-text">$</div></div>
                    <input formControlName="cost" class="form-control form-control-sm" type="text" required>
                </div>
                <div *ngIf="serviceForm.controls.cost.touched">
                    <div *ngIf="serviceForm.controls.cost.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                    <div *ngIf="serviceForm.controls.cost.errors?.pattern && !isCost() ">
                        <small class="text-danger">Cost must have a valid currency value.</small>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-4">
                <h6>Fleet<span class="text-danger">*</span> :</h6>
                <select [id]="fleet_id" class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id" required> 
                    <option  selected *ngIf="isEditMode==false" disabled>Select..</option>
                    <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.fleet_id_num}} ({{fl.rego}})</option>
                </select>
                <div *ngIf="serviceForm.controls.fleet_id.touched">
                    <div *ngIf="serviceForm.controls.fleet_id.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-4" >
                <h6>Receipt No:</h6>
                <input formControlName="receipt_no" class="form-control form-control-sm" type="text"> 
               
            </div>

            <div class="form-group col-md-4" >
                <h6>Description<span class="text-danger">*</span> :</h6>
                <input formControlName="service_description" class="form-control form-control-sm" type="text" required> 
                <div *ngIf="serviceForm.controls.service_description.touched">
                    <div *ngIf="serviceForm.controls.service_description.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                </div>
            </div>
            <div class="form-group col-md-4" >
                <h6>Fault:</h6>
                <input formControlName="fault" class="form-control form-control-sm" type="text"> 
            </div>
            <div class="form-group col-md-4" >
                <h6>Hours:</h6>
                <input formControlName="hours" class="form-control form-control-sm" type="text">
                <div *ngIf="serviceForm.controls.hours.touched">
                    <div *ngIf="serviceForm.controls.hours.errors?.pattern">
                        <small class="text-danger" >Hours must be a valid numeric value.</small>
                    </div>
                </div> 
            </div>
            <div class="form-group col-md-4" >
                <h6>Service Odometer<span class="text-danger">*</span>:</h6>
                <input formControlName="mileage" class="form-control form-control-sm" type="text"> 
                <div *ngIf="serviceForm.controls.mileage.touched">
                    <div *ngIf="serviceForm.controls.mileage.errors?.pattern">
                        <small class="text-danger" >Service Odometer must be a valid numeric value.</small>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-4">
                <h6>Driver:</h6>
                <select [id]="driver_id" class="form-control form-control-sm" placeholder="Select" formControlName="driver_id"> 
                    <option disabled selected *ngIf="isEditMode==false">Select..</option>
                    <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.full_name}}</option>
                </select>
            </div>
            
            <div class="form-group col-md-4" >
                <h6>Note:</h6>
                <textarea class="form-control form-control-sm" formControlName="note" rows="4" cols="50"></textarea>
            </div>
            <div class="col-md-8">
                <div class="form-group" *ngIf ="(fileExists==true)">
                    <h6>File:</h6><br/>
                    <label>{{service?.file}}</label> <button class="btn btn-primary btn-sm" type="button" (click)="removeFile(prefixService)">Remove File</button>
                </div>
                <div class="form-group" *ngIf ="(fileExists==false)">
                    <h6>File:</h6>
                    <app-image-uploader (passImage)="getFile($event, prefixService)"></app-image-uploader>
                </div>
                <small><i>*Note: Allowed files are *.pdf, image files (*png,*.jpg,*.gif).</i></small>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!serviceForm.valid || spinner == true">Save</button>
        <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!serviceForm.valid || spinner == true">Save Changes</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="modalClose()" ngbAutofocus>Cancel</button>
    </div>
</form> 
</ng-template>
<!-- END OF MODAL ADD DAMAGE REPORT FORM -->

<!-- START OF DELETE OBJECT FORM -->
<ng-template #modalDeleteObj let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete {{title}}</h5>
        <button type="button" class="close" (click)="modalClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body bg-gray">
        <div class="row pt-0">
            <div class="col-md-12">
            Do you really want to delete this {{title}}?
            <h5>{{objToDelete.rego}}</h5>
            <p style="word-wrap: break-all">{{fileToDelete}}</p>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteObj(objToDelete)"  [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="modalClose()" ngbAutofocus>Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE OBJECT FORM -->


<!-- START SERVICE PRINT-->
<div id="service-print-section" style="display:none">
    <table style="width:100%">
        <tr>
            <th align="left" *ngIf="showDate">DATE</th>
            <th align="left" *ngIf="showRego">REGO</th>
            <th align="left" *ngIf="showFleetType">FLEET TYPE</th>
            <th align="left" *ngIf="showDescription">DESCRIPTION</th>
            <th align="left" *ngIf="showOdometer">ODOMETER</th>
            <th align="left" *ngIf="showServiceInterval">SERVICE INTERVAL</th>
            <th align="left" *ngIf="showSupplier">SUPPLIER</th>
            <th align="left" *ngIf="showCost">COST</th>
            <th align="left" *ngIf="showReceiptNo">RECEIPT NO</th>
            <th align="left" *ngIf="showFile">FILE</th>
        </tr>
        <tr *ngFor="let row of service_rows">
            <td *ngIf="showDate">{{ (formatDate(row.date_done) !== null && row.date_done != '0000-00-00') ? (formatDate(row.date_done) | date: 'dd MMM yyyy') : "No Date"  }}  </td> 
            <td *ngIf="showRego">{{row.rego}}</td>
            <td *ngIf="showFleetType">{{row.fleet_type}} - {{row.subtype}}</td>
            <td *ngIf="showDescription">{{row.service_description}}</td>
            <td *ngIf="showOdometer"> 
                <span *ngIf = "(row.mileage > 0) &&((row.mileage + row.service_interval) >= row.current_odometer)"><span>{{(row.mileage + row.service_interval) - row.current_odometer | number:'1.0-0'}}</span></span> 
                <span *ngIf = "(row.mileage > 0) && (row.current_odometer > (row.mileage + row.service_interval))">Missed service by <span>{{((row.mileage + row.service_interval) - row.current_odometer) * -1  | number:'1.0-0'}}</span> klms</span> 
                <span *ngIf="row.mileage == 0 && (row.current_odometer > row.service_interval)">Missed service by<span> {{ (row.service_interval - row.current_odometer) * -1  | number:'1.0-0'}}</span> klms. No service odometer for this record.</span> 
                <span *ngIf="row.mileage == 0 && (row.service_interval > row.current_odometer)"><span>{{ row.service_interval - row.current_odometer  | number:'1.0-0'}}</span> klms to next Service. No service odometer for this record.</span></td>
            <td *ngIf="showServiceInterval">{{row.service_interval}}</td>
            <td *ngIf="showSupplier">{{row.provider}}</td>
            <td *ngIf="showCost">${{row.cost  | number:'3.2-5'}}</td>
            <td *ngIf="showReceiptNo">{{row.receipt_no}}</td>
            <td *ngIf="showFile"><div class="justify-content-left"><a href="{{folderPath}}{{row.file}}" target="_new">{{row.file}}</a></div></td>
        </tr>
    </table>
</div>
<!-- END PRINT -->